import { render, staticRenderFns } from "./BCXMessengerConfirm.vue?vue&type=template&id=4ab92792&scoped=true"
import script from "./BCXMessengerConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerConfirm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerConfirm.vue?vue&type=style&index=0&id=4ab92792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab92792",
  null
  
)

export default component.exports